import React, { useState, useEffect } from "react";
import {
  signInWithEmailAndPassword,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
  updatePassword,
  sendPasswordResetEmail,
  setPersistence,
  browserSessionPersistence,
  signOut,
  sendEmailVerification,
} from "firebase/auth";
import { Spin } from "antd";
import { httpsCallable } from "firebase/functions";
import { EyeOutlined } from "@ant-design/icons";
import "react-phone-number-input/style.css";
import { getAuth } from "firebase/auth";
import PhoneInput from "react-phone-number-input";
import { testSlice } from "../../redux/store";
import "./Login.css";
import axios from "axios"; // Im
import { Switch, Button } from "antd";
import { auth, db, functions, googleProvider } from "../../database/firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { openErrorNotification } from "../../Components/Notifications/errorNotification";
import { openSuccesNotification } from "../../Components/Notifications/succesNotification";
import {
  startEnrollMultiFactor,
  finishMfaSignIn,
  getMfaResolver,
  startMfaSignin,
  finishEnrollMultiFactor,
  updateDocDatabase,
} from "../../database";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
const { actions } = testSlice;
const { SESSION } = actions;

const Login = ({ setPostLoginLoading }) => {
  const dispatch = useDispatch();
  const session = useSelector((state) => state.session);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordRepet, setPasswordRepet] = useState("");
  const [changePassword, setChangePassword] = useState("");
  const [userObject, setUser] = useState(null);
  const [mfaCode, setMfaCode] = useState("");
  const [ramanLogat, setRamanLogat] = useState(true);
  const [forgotPassword, setForgotPassword] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [phone, setPhone] = useState("");
  const [sended, setSended] = useState(false);
  const [res, setRes] = useState(false);
  const [otp, setOtp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hideButton, setHideButton] = useState(false);
  const [introduCode, setIntroduCode] = useState(false);
  const [userIp, setUserIp] = useState("");
  const getUserIp = async () => {
    try {
      const response = await axios.get("https://api.ipify.org?format=json"); // Folosește un API pentru a obține IP-ul public
      setUserIp(response.data.ip);
    } catch (error) {
      console.error("Eroare la obținerea IP-ului:", error);
    }
  };
  useEffect(() => {
    getUserIp(); // Obține IP-ul când componenta este montată

    // Check for URL parameters to auto-fill email and password
    const urlParams = new URLSearchParams(window.location.search);
    const emailParam = urlParams?.get("email");
    const passParam = urlParams?.get("pass");

    if (emailParam && passParam) {
      setEmail(emailParam);
      setPassword(passParam);
    }

    // Verifică dacă utilizatorul se întoarce după redirect Google
    const handleRedirectResult = async () => {
      try {
        const authInProgress = localStorage.getItem("google_auth_in_progress");
        console.log("Auth in progress from localStorage:", authInProgress);
        console.log("Current URL:", window.location.href);
        console.log("URL search params:", window.location.search);

        // Verifică session storage înainte să se șteargă
        console.log("Session storage keys:", Object.keys(sessionStorage));
        for (let i = 0; i < sessionStorage?.length; i++) {
          const key = sessionStorage.key(i);
          if (key && key.includes("firebase")) {
            console.log(`Session storage ${key}:`, sessionStorage.getItem(key));
          }
        }

        console.log("Checking for redirect result...");
        console.log("Current user before getRedirectResult:", auth.currentUser);
        const result = await getRedirectResult(auth);
        console.log("Redirect result:", result);
        console.log("Current user after getRedirectResult:", auth.currentUser);

        if (authInProgress) {
          localStorage.removeItem("google_auth_in_progress");
        }

        if (result) {
          // Utilizatorul s-a autentificat prin redirect
          const user = result.user;
          console.log("Redirect auth success:", user);
          console.log("User email:", user.email);
          console.log("User displayName:", user.displayName);

          // Verifică dacă este o cerere de la aplicația mobilă
          const mobileRedirectUrl = localStorage.getItem("mobile_redirect_url");

          // Așteaptă puțin pentru ca trigger-ul să-și facă treaba
          await new Promise((resolve) => setTimeout(resolve, 2000));

          // Verifică dacă utilizatorul încă există
          const currentUser = auth.currentUser;
          if (!currentUser) {
            throw new Error("Contul a fost șters - nu există în sistem");
          }

          const document = doc(db, "users", user.uid);
          const snap = await getDoc(document);

          setUser(user);
          if (snap.exists()) {
            const data = snap.data();
            const isGoogleUser = user.providerData?.some(
              (provider) => provider.providerId === "google.com"
            );

            if (data.reset === true && !isGoogleUser) {
              setRes(true);
              localStorage.setItem("sendEmail", "done");
              setIntroduCode(false);
            } else {
              openSuccesNotification(
                `Bine ai venit, ${user.displayName || user.email}!`
              );

              // Dacă este o cerere mobilă, redirectează la aplicație cu token-ul
              if (mobileRedirectUrl) {
                localStorage.removeItem("mobile_redirect_url");
                const token = await user.getIdToken();
                const decodedRedirectUrl =
                  decodeURIComponent(mobileRedirectUrl);
                window.location.href = `${decodedRedirectUrl}?token=${token}`;
                return;
              }
            }
          } else {
            console.log("User not found in Firestore, signing out...");
            await signOut(auth);
            openErrorNotification(
              "Nu există cont asociat cu acest email Google. Contactați administratorul pentru a vă crea cont."
            );
          }
        } else {
          console.log(
            "No redirect result found, user probably just loaded the page normally"
          );
        }
      } catch (error) {
        console.error("Redirect result error:", error);
        if (
          error.message.includes("șters") ||
          error.code === "auth/user-not-found"
        ) {
          openErrorNotification(
            "Nu există cont asociat cu acest email Google. Contactați administratorul pentru a vă crea cont."
          );
        } else {
          openErrorNotification("Eroare la autentificare: " + error.message);
        }
      }
    };

    handleRedirectResult();
  }, []);
  const handleLoginCode = async (e) => {
    e.preventDefault();

    try {
      const validateCodeFunction = httpsCallable(functions, "validateCode");
      const response = await validateCodeFunction({
        code: mfaCode,
        email: email,
      });

      if (response.data.success === true) await onSubmit();
    } catch (err) {
      setMfaCode("");
    }
  };

  const handleGoogleSignIn = async () => {
    setLoading(true);
    try {
      // Verifică dacă este o cerere de la aplicația mobilă
      const urlParams = new URLSearchParams(window.location.search);
      const isMobileRequest = urlParams?.get("mobile") === "true";
      const redirectUrl = urlParams?.get("redirect");

      if (!ramanLogat) {
        await setPersistence(auth, browserSessionPersistence);
        dispatch(SESSION({ ...session, dangerMode: true }));
      }

      // Detectează environment și platform pentru a alege metoda potrivită
      const isDevelopment = process.env.NODE_ENV === "development";
      const isMobile =
        /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        );
      const isWebView =
        /wv|WebView/i.test(navigator.userAgent) || window.ReactNativeWebView;

      console.log("Environment:", isDevelopment ? "development" : "production");
      console.log(
        "Mobile:",
        isMobile,
        "WebView:",
        isWebView,
        "Mobile request:",
        isMobileRequest
      );

      // Salvează informațiile pentru redirectul mobil
      if (isMobileRequest && redirectUrl) {
        localStorage.setItem("mobile_redirect_url", redirectUrl);
      }

      let result;
      if (isDevelopment || isMobileRequest) {
        // Pentru development sau cereri mobile folosește popup
        console.log("Using signInWithPopup...");
        result = await signInWithPopup(auth, googleProvider);

        // Dacă este o cerere mobilă și autentificarea a reușit
        if (isMobileRequest && result.user) {
          window.location.href = "/mobile-auth";
          return;
        }
      } else {
        // Pentru production folosește redirect
        console.log("Using signInWithRedirect for production...");
        localStorage.setItem("google_auth_in_progress", "true");
        await signInWithRedirect(auth, googleProvider);
        return; // Se va reîncărca pagina după redirect
      }
    } catch (error) {
      console.error("Eroare Google Sign-in:", error);
      if (error.code === "auth/popup-closed-by-user") {
        openErrorNotification("Popup-ul de autentificare a fost închis.");
      } else if (
        error.code === "auth/user-not-found" ||
        error.message.includes("șters")
      ) {
        openErrorNotification(
          "Nu există cont asociat cu acest email Google. Contactați administratorul pentru a vă crea cont."
        );
      } else {
        openErrorNotification(
          "Eroare la autentificarea cu Google: " + error.message
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (_, again = false) => {
    if (!ramanLogat) {
      dispatch(SESSION({ ...session, dangerMode: true }));
      await setPersistence(auth, browserSessionPersistence).then(async () => {
        try {
          const userCredential = await signInWithEmailAndPassword(
            auth,
            email.trim(),
            password
          );

          const user = userCredential.user;
          const document = doc(db, "users", user.uid);
          const snap = await getDoc(document);

          setUser(user);
          if (snap.exists()) {
            const data = snap.data();
            // Verifică dacă utilizatorul s-a autentificat cu Google
            const isGoogleUser = user.providerData?.some(
              (provider) => provider.providerId === "google.com"
            );

            if (data.reset === true && !isGoogleUser) {
              // Doar pentru utilizatorii care nu s-au autentificat cu Google
              setRes(true);
              localStorage.setItem("sendEmail", "done");
              setIntroduCode(false);
            }
          }
        } catch (error) {
          if (error.code === "auth/internal-error") {
            setIntroduCode(true);
          } else {
            openErrorNotification(error.message);
          }
        }
      });
    } else {
      try {
        const userCredential = await signInWithEmailAndPassword(
          auth,
          email.trim(),
          password
        );

        const user = userCredential.user;
        const document = doc(db, "users", user.uid);
        const snap = await getDoc(document);

        setUser(user);
        if (snap.exists()) {
          const data = snap.data();
          // Pentru autentificarea cu email/parolă, verifică reset-ul normal
          if (data.reset === true) {
            setRes(true);
            localStorage.setItem("sendEmail", "done");
            setIntroduCode(false);
          }
        }
      } catch (error) {
        if (error.code === "auth/internal-error") {
          setIntroduCode(true);
        } else {
          openErrorNotification(error.message);
        }
      }
    }
  };

  const changePasswordFunc = async (e) => {
    e.preventDefault();
    if (passwordRepet !== changePassword) {
      openErrorNotification("Passwords do not match");
      return;
    }
    try {
      await updatePassword(userObject, changePassword);
      setRes(false);
      const document = doc(db, "users", userObject.uid);
      await updateDocDatabase("users", userObject.uid, { reset: false });

      // Clear URL parameters after password change
      const url = new URL(window.location);
      url.searchParams?.delete("email");
      url.searchParams?.delete("pass");
      window.history.replaceState(
        {},
        document.title,
        url.pathname + url.search
      );

      signOut(auth);
      window.location.reload();
    } catch (error) {
      openErrorNotification(error.message);
    }
  };

  const setChangePasswordLink = async (e) => {
    e.preventDefault();
    try {
      await sendPasswordResetEmail(auth, email);
      setSended(true);
    } catch (error) {
      openErrorNotification(error.message);
    }
  };

  return (
    <>
      <div className="limiter">
        <div
          className="container-login100"
          style={{
            backgroundImage: `url('${process.env.REACT_APP_BACKGROUND}')`,
          }}
        >
          <div className="wrap-login100">
            <div
              className="login100-pic js-tilt"
              data-tilt
              style={{ paddingTop: "5%" }}
            >
              <img
                src={process.env.REACT_APP_LOGO}
                alt="IMG"
                width="200px"
                height="200px"
              />
            </div>

            {forgotPassword ? (
              <form className="login100-form validate-form">
                <span className="login100-form-title">Resetează Parola</span>
                {!sended ? (
                  <>
                    <div
                      className="wrap-input100 validate-input"
                      data-validate="Valid email is required: ex@abc.xyz"
                    >
                      <input
                        className="input100"
                        type="text"
                        name="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <span className="focus-input100"></span>
                      <span className="symbol-input100">
                        <i className="fa fa-envelope" aria-hidden="true"></i>
                      </span>
                    </div>
                    <div className="container-login100-form-btn">
                      <button
                        className="login100-form-btn"
                        onClick={setChangePasswordLink}
                      >
                        Schimbă parola
                      </button>
                    </div>
                  </>
                ) : (
                  <div
                    className="wrap-input100 validate-input"
                    data-validate="Valid email is required: ex@abc.xyz"
                  >
                    Ti-am trimis un email, continua de acolo
                    <span className="focus-input100"></span>
                    <span className="symbol-input100">
                      <i className="fa fa-envelope" aria-hidden="true"></i>
                    </span>
                  </div>
                )}
                <div
                  className="text-center p-t-12"
                  style={{ textAlign: "center" }}
                >
                  <span
                    className="txt1"
                    onClick={() => setForgotPassword(false)}
                  >
                    Ai uitat parola?
                  </span>
                </div>
              </form>
            ) : (
              <>
                {introduCode && (
                  <form className="login100-form validate-form">
                    <span className="login100-form-title">
                      Introdu codul primit in email
                    </span>
                    <div
                      className="wrap-input100 validate-input"
                      style={{
                        justifyContent: "center",
                        margin: "auto",
                        display: "flex",
                        textAlign: "center",
                      }}
                    >
                      <input
                        type="text"
                        name="mfaCode"
                        className="input100"
                        value={mfaCode}
                        onChange={(e) => setMfaCode(e.target.value)}
                        placeholder="Cod Email"
                        pattern="^[0-9]*$"
                        required
                      />
                    </div>
                    <div className="container-login100-form-btn">
                      {loading === false && (
                        <button
                          id="login-btn"
                          className="login100-form-btn"
                          onClick={async (e) => {
                            setLoading(true);
                            await handleLoginCode(e);
                            setLoading(false);
                          }}
                        >
                          Verifica cod
                        </button>
                      )}
                    </div>
                  </form>
                )}

                {!res && !introduCode && (
                  <div className="login100-form validate-form">
                    <span className="login100-form-title">
                      Intră în catalog
                    </span>
                    {hideButton === false && (
                      <div>
                        <div
                          className="wrap-input100 validate-input"
                          data-validate="Valid email is required: ex@abc.xyz"
                        >
                          <input
                            className="input100"
                            type="text"
                            name="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                          <span className="focus-input100"></span>
                          <span className="symbol-input100">
                            <i
                              className="fa fa-envelope"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </div>
                        <div
                          className="wrap-input100 validate-input"
                          data-validate="Password is required"
                        >
                          <input
                            className="input100"
                            type={showPassword ? "text" : "password"}
                            name="pass"
                            placeholder="Parola"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          />

                          <Button
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "20px",
                            }}
                            onClick={() => setShowPassword(!showPassword)}
                            icon={<EyeOutlined />}
                          />
                          <span className="focus-input100"></span>
                          <span className="symbol-input100">
                            <i className="fa fa-lock" aria-hidden="true"></i>
                          </span>
                        </div>
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            margin: "auto",
                            justifyContent: "center",
                          }}
                        >
                          <Switch
                            checkedChildren="Retine contul"
                            unCheckedChildren="Nu retine contul"
                            checked={ramanLogat}
                            onChange={(e) => setRamanLogat(e)}
                          />
                        </div>
                        {ramanLogat === false && (
                          <p style={{ paddingTop: "3px", color: "red" }}>
                            Atenție! Veți fi deconectat la 3 min. de neactiviate
                          </p>
                        )}
                      </div>
                    )}
                    <div className="container-login100-form-btn">
                      {loading === false && (
                        <button
                          className="login100-form-btn"
                          id="login-btn"
                          onClick={async (e) => {
                            setLoading(true);
                            await onSubmit(e);
                            setLoading(false);
                          }}
                        >
                          Intra in cont
                        </button>
                      )}
                      {/*
                      <div style={{ margin: "15px 0" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "15px 0",
                          }}
                        >
                          <hr
                            style={{
                              flex: 1,
                              border: "none",
                              borderTop: "1px solid #ddd",
                            }}
                          />
                          <span
                            style={{
                              margin: "0 15px",
                              color: "#666",
                              fontSize: "14px",
                            }}
                          >
                            sau
                          </span>
                          <hr
                            style={{
                              flex: 1,
                              border: "none",
                              borderTop: "1px solid #ddd",
                            }}
                          />
                        </div>

                        {loading === false && (
                          <button
                            className="login100-form-btn"
                            onClick={handleGoogleSignIn}
                            style={{
                              backgroundColor: "#4285f4",
                              border: "none",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "10px",
                            }}
                          >
                            <svg width="18" height="18" viewBox="0 0 24 24">
                              <path
                                fill="#fff"
                                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                              />
                              <path
                                fill="#fff"
                                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                              />
                              <path
                                fill="#fff"
                                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                              />
                              <path
                                fill="#fff"
                                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                              />
                            </svg>
                            Intra cu Google
                          </button>
                        )}
                      </div>
*/}
                      <div
                        id="2fa-captcha"
                        style={{ display: "flex", justifyContent: "center" }}
                      ></div>
                    </div>

                    <div
                      id="recaptcha"
                      style={{ display: auth.currentUser ? "none" : "block" }}
                    />

                    <div
                      className="text-center p-t-12"
                      style={{ textAlign: "center" }}
                    >
                      <span
                        className="txt1"
                        onClick={() => setForgotPassword(true)}
                      >
                        Ai uitat parola?
                      </span>
                    </div>
                  </div>
                )}
                {res && !introduCode && (
                  <form className="login100-form validate-form">
                    <span className="login100-form-title">
                      Alege noua parolă
                    </span>
                    <div
                      className="wrap-input100 validate-input"
                      data-validate="Valid email is required: ex@abc.xyz"
                    >
                      <input
                        className="input100"
                        type="password"
                        name="password"
                        placeholder="Parola"
                        value={changePassword}
                        onChange={(e) => setChangePassword(e.target.value)}
                      />
                      <span className="focus-input100"></span>
                      <span className="symbol-input100">
                        <i className="fa fa-envelope" aria-hidden="true"></i>
                      </span>
                    </div>
                    <div
                      className="wrap-input100 validate-input"
                      data-validate="Password is required"
                    >
                      <input
                        className="input100"
                        type="password"
                        name="pass"
                        placeholder="Repeta parola"
                        value={passwordRepet}
                        onChange={(e) => setPasswordRepet(e.target.value)}
                      />
                      <span className="focus-input100"></span>
                      <span className="symbol-input100">
                        <i className="fa fa-lock" aria-hidden="true"></i>
                      </span>
                    </div>
                    <div className="container-login100-form-btn">
                      <button
                        className="login100-form-btn"
                        onClick={changePasswordFunc}
                      >
                        Schimbă parola
                      </button>
                    </div>
                  </form>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
